
import { IIndexDB } from "@interfaces/IndexDB";
import emitter from "./emitter";


export function saveOrUpdateRegistrationData<T extends IIndexDB>(table: string, updatedData: T) {
    const { id } = updatedData;
    const dbPromise = openDatabase(table);

    if(!id){return}
    dbPromise.onsuccess = (event: any) => {
        const db = event.target.result;
        const transaction = db.transaction(table, 'readwrite');
        const registrations = transaction.objectStore(table);
        const getRequest = registrations.get(id);

        getRequest.onsuccess = () => {
            const existingData = getRequest.result;

            if (existingData) {
                updatedData = { ...existingData, ...updatedData };
            }
            const putRequest = registrations.put(updatedData);

            putRequest.onsuccess = () => {
                emitter.emit("playlistUpdate");
                console.log('Registro atualizado com sucesso.');
            };

            putRequest.onerror = (event: any) => {
                console.error('Erro ao atualizar o registro:', event.target.error);
            };
            
        };

        transaction.oncomplete = () => {
            db.close();
        };
    };

    dbPromise.onerror = (event: any) => {
        console.error('Erro ao abrir o banco de dados:', event.target.error);
    };
}


export function saveRegistrationData<T extends IIndexDB>(databaseTable: string, data: T) {
    const dbPromise = openDatabase(databaseTable);

    dbPromise.onsuccess = (event: any) => {
        const db = event.target.result;

        const transaction = db.transaction(databaseTable, 'readwrite');
        const registrations = transaction.objectStore(databaseTable);

        const putRequest = registrations.add(data);

        putRequest.onsuccess = (e:any) => {
            emitter.emit("playlistUpdate");
            console.log('Registro salvo com sucesso.', e);
        };

        putRequest.onerror = (event: any) => {
            console.error('Erro ao salvar o registro:', event.target.error);
        };

        transaction.oncomplete = () => {
            db.close();
        };
    };

    dbPromise.onerror = (event: any) => {
        console.error('Erro ao abrir o banco de dados:', event.target.error);
    };
}

export function getRegistrationData<T extends IIndexDB>(databaseTable: string, id?: any): Promise<T> {
    return new Promise((resolve, reject) => {
        const dbPromise = openDatabase(databaseTable);

        dbPromise.onsuccess = (event: any) => {
            const db = event.target.result;
            const transaction = db.transaction(databaseTable, 'readonly');
            const registrations = transaction.objectStore(databaseTable);
            let getRequest = registrations;

            if (id) {
                getRequest = getRequest.get(id);
            } else {
                getRequest = registrations.getAll();
            }

            getRequest.onsuccess = () => {
                const registrationData = getRequest.result;
                resolve(registrationData);
                db.close();
            };

            getRequest.onerror = (event: any) => {
                console.error('Error fetching registration data:', event.target.error);
                reject(event.target.error);
            };

            transaction.oncomplete = () => {
                db.close();
            };
        };

        dbPromise.onerror = (event: any) => {
            console.error('Error opening database:', event.target.error);
            reject(event.target.error);
        };
    });
}

export function getAllRegistrations(databaseTable: string, callback: any) {
    getRegistrationData(databaseTable)
        .then((allRegistrations) => {
            callback(allRegistrations);
        })
        .catch((error) => {
            console.error('Erro ao obter todos os registros:', error);
        });
}


export function updateRegistrationData<T extends IIndexDB>(databaseTable: string, data: T) {
    const  {updatedData}:T  = data;
    const dbPromise = openDatabase(databaseTable);

    dbPromise.onsuccess = (event: any) => {
        const db = event.target.result;
        const transaction = db.transaction(databaseTable, 'readwrite');
        const registrations = transaction.objectStore(databaseTable);
        const getRequest = registrations.get(data);

        getRequest.onsuccess = () => {
            const existingData:T = getRequest.result;
            const updatedRegistration = { ...existingData, ...updatedData };

            const putRequest = registrations.put(updatedRegistration);

            putRequest.onsuccess = () => {
                emitter.emit("playlistUpdate");
                console.log('Registro atualizado com sucesso.');
            };

            putRequest.onerror = (event: any) => {
                console.error('Erro ao atualizar o registro:', event.target.error);
            };
        };

        transaction.oncomplete = () => {
            db.close();
        };
    };

    dbPromise.onerror = (event: any) => {
        console.error('Erro ao abrir o banco de dados:', event.target.error);
    };
}

export function deleteRegistrationData(databaseTable: string, data: any) {
    const dbPromise = openDatabase(databaseTable);

    dbPromise.onsuccess = (event: any) => {
        const db = event.target.result;
        const transaction = db.transaction(databaseTable, 'readwrite');
        const registrations = transaction.objectStore(databaseTable);

        const deleteRequest = registrations.delete(data);

        deleteRequest.onsuccess = () => {
            emitter.emit("playlistUpdate");
            console.log('Registro excluído com sucesso.');
        };

        deleteRequest.onerror = (event: any) => {
            console.error('Erro ao excluir o registro:', event.target.error);
        };

        transaction.oncomplete = () => {
            db.close();
        };
    };

    dbPromise.onerror = (event: any) => {
        console.error('Erro ao abrir o banco de dados:', event.target.error);
    };
}

export function deleteDatabase(databaseTable: string) {
    const deleteDbPromise = window.indexedDB.deleteDatabase(databaseTable);

    deleteDbPromise.onsuccess = () => {
        emitter.emit("playlistUpdate");
        console.log(`Database ${databaseTable} deleted successfully.`);
    };

    deleteDbPromise.onerror = (event: any) => {
        console.error(`Error deleting database ${databaseTable}:`, event.target.error);
    };
}


function openDatabase(databaseTable: string) {
    const dbPromise = window.indexedDB.open(databaseTable, 1);

    dbPromise.onupgradeneeded = (event: any) => {
        const db = event.target.result;
        db.createObjectStore(databaseTable, { keyPath: 'id' });
    };

    return dbPromise;
}